import React from 'react';
import { FaVideo, FaCheckCircle, FaTimesCircle, FaPercent } from 'react-icons/fa';
import { CCTVStats } from '../utils/cctvTypes';

interface CCTVStatCardsProps {
  stats: CCTVStats;
}

const CCTVStatCards: React.FC<CCTVStatCardsProps> = ({ stats }) => {
  // Calculate uptime percentage
  const uptimePercentage = stats.totalCameras > 0
    ? ((stats.activeCameras / stats.totalCameras) * 100).toFixed(1)
    : '0';

  return (
    <div className="cctv-summary-section">
      <div className="summary-cards">
        <div className="summary-card total">
          <div className="card-icon">
            <FaVideo />
          </div>
          <div className="card-content">
            <span className="card-value">{stats.totalCameras}</span>
            <span className="card-label">Total Cameras</span>
          </div>
        </div>

        <div className="summary-card working">
          <div className="card-icon">
            <FaCheckCircle />
          </div>
          <div className="card-content">
            <span className="card-value">{stats.activeCameras}</span>
            <span className="card-label">Working</span>
          </div>
          <div className="card-badge success">
            {stats.totalCameras > 0 ? ((stats.activeCameras / stats.totalCameras) * 100).toFixed(0) : 0}%
          </div>
        </div>

        <div className="summary-card non-working">
          <div className="card-icon">
            <FaTimesCircle />
          </div>
          <div className="card-content">
            <span className="card-value">{stats.inactiveCameras}</span>
            <span className="card-label">Non-Working</span>
          </div>
          <div className="card-badge danger">
            {stats.totalCameras > 0 ? ((stats.inactiveCameras / stats.totalCameras) * 100).toFixed(0) : 0}%
          </div>
        </div>

        <div className="summary-card uptime">
          <div className="card-icon">
            <FaPercent />
          </div>
          <div className="card-content">
            <span className="card-value">{uptimePercentage}%</span>
            <span className="card-label">System Uptime</span>
          </div>
          <div className="uptime-bar">
            <div
              className="uptime-progress"
              style={{ width: `${uptimePercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CCTVStatCards;
